(function () {
  'use strict';

  var states = 'AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' ');
  var names = 'Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming'.split('|');
  var active = null;
  var serial = 0;
  var ps = window.PS = window.PS || {};

  function field(root, name) { return root.querySelector('[data-ps-' + name + ']'); }
  function rootNow() { return document.querySelector('#main-cart-footer [data-ps-cart-shipping-quote]'); }
  function current(root, ticket) { return root && rootNow() === root && active && active.root === root && active.ticket === ticket; }
  function destination(root) {
    var state = field(root, 'shipping-state').value;
    var zip = field(root, 'shipping-zip').value.replace(/^\s+|\s+$/g, '');
    if (states.indexOf(state) < 0 || !/^\d{5}(?:-\d{4})?$/.test(zip)) return null;
    return { state: state, zip: zip };
  }
  function sameDestination(a, b) { return a && b && a.state === b.state && a.zip === b.zip; }
  function canonical(value) {
    var keys, i, parts;
    if (value === null || typeof value !== 'object') return JSON.stringify(value);
    if (Object.prototype.toString.call(value) === '[object Array]') {
      parts = [];
      for (i = 0; i < value.length; i += 1) parts.push(canonical(value[i]));
      return '[' + parts.join(',') + ']';
    }
    keys = Object.keys(value).sort(); parts = [];
    for (i = 0; i < keys.length; i += 1) parts.push(JSON.stringify(keys[i]) + ':' + canonical(value[keys[i]]));
    return '{' + parts.join(',') + '}';
  }
  function moneyNumber(value) { return typeof value === 'number' && isFinite(value) && value >= 0 && value <= 9007199254740991 && Math.floor(value) === value; }
  function weightNumber(value) { return typeof value === 'number' && isFinite(value) && value >= 0; }
  function cartFacts(cart) {
    var lines = [], i, line, count = 0, hasShippingLine = false;
    if (!cart || Object.prototype.toString.call(cart.items) !== '[object Array]' || !cart.items.length || !moneyNumber(cart.item_count) || !cart.item_count || !/^[A-Z]{3}$/.test(cart.currency || '') || cart.requires_shipping !== true || !weightNumber(cart.total_weight) || !moneyNumber(cart.original_total_price) || !moneyNumber(cart.total_price) || !moneyNumber(cart.items_subtotal_price) || !moneyNumber(cart.total_discount)) return null;
    for (i = 0; i < cart.items.length; i += 1) {
      line = cart.items[i];
      if (!line || typeof line !== 'object' || !line.id || !moneyNumber(line.quantity) || !line.quantity || typeof line.requires_shipping !== 'boolean' || !moneyNumber(line.line_price) || !moneyNumber(line.final_line_price) || !moneyNumber(line.original_line_price) || !moneyNumber(line.total_discount)) return null;
      count += line.quantity;
      if (line.requires_shipping) hasShippingLine = true;
      lines.push({ id: line.id, quantity: line.quantity, properties: line.properties || {}, requires_shipping: line.requires_shipping, selling_plan_allocation: line.selling_plan_allocation || null, line_price: line.line_price, final_line_price: line.final_line_price, original_line_price: line.original_line_price, total_discount: line.total_discount, discounts: line.discounts || [], discount_allocations: line.discount_allocations || [] });
    }
    if (count !== cart.item_count || !hasShippingLine) return null;
    return { currency: cart.currency, fingerprint: canonical({ currency: cart.currency, item_count: cart.item_count, original_total_price: cart.original_total_price, total_price: cart.total_price, total_weight: cart.total_weight, requires_shipping: cart.requires_shipping, items_subtotal_price: cart.items_subtotal_price, total_discount: cart.total_discount, cart_level_discount_applications: cart.cart_level_discount_applications || [], lines: lines }) };
  }
  function request(method, url, done) {
    var xhr = new XMLHttpRequest();
    var finished = false;
    function finish(error, data) { if (finished) return; finished = true; done(error, data); }
    xhr.open(method, url, true);
    xhr.timeout = 6000;
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      var data;
      if (xhr.status < 200 || xhr.status >= 300) { finish('http'); return; }
      try { data = JSON.parse(xhr.responseText); } catch (_e) { finish('invalid'); return; }
      finish(null, data);
    };
    xhr.onerror = function () { finish('network'); };
    xhr.ontimeout = function () { finish('timeout'); };
    xhr.onabort = function () { finish('cancelled'); };
    try { xhr.send(null); } catch (_e) { finish('network'); }
    return xhr;
  }
  function base(root) {
    var path = root.getAttribute('data-ps-root') || '/';
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/?$/i.test(path) ? path.replace(/\/?$/, '/') : '/';
  }
  function params(where) { return 'shipping_address%5Bzip%5D=' + encodeURIComponent(where.zip) + '&shipping_address%5Bcountry%5D=United%20States&shipping_address%5Bprovince%5D=' + encodeURIComponent(names[states.indexOf(where.state)]); }
  function clearDisplay(root, message) {
    var list = field(root, 'shipping-rates');
    while (list.firstChild) list.removeChild(list.firstChild);
    list.hidden = true;
    field(root, 'shipping-message').textContent = message || '';
  }
  function invalidate(message) {
    var old = active;
    active = null;
    serial += 1;
    if (old && old.busy && old.done) old.done({ status: 'stale', message: 'The cart or ZIP code changed. Check shipping options again.' });
    if (old && old.xhr && typeof old.xhr.abort === 'function') old.xhr.abort();
    if (old && old.timer) window.clearTimeout(old.timer);
    if (old && rootNow() === old.root) {
      field(old.root, 'shipping-check').disabled = false;
      clearDisplay(old.root, message || 'Your cart or ZIP code changed. Check shipping options again.');
    }
  }
  function stillCurrent(root, ticket) {
    if (current(root, ticket)) return true;
    if (active && active.ticket === ticket) invalidate('');
    return false;
  }
  function fail(root, ticket, message) {
    if (!stillCurrent(root, ticket)) return;
    active.busy = false;
    active.quote = null;
    field(root, 'shipping-check').disabled = false;
    clearDisplay(root, message);
    if (active.done) active.done({ status: 'unavailable', message: message });
  }
  function ratesFrom(data, currency) {
    var list = data && data.shipping_rates, result = [], i, rate, name, price, rateCurrency;
    if (!list || Object.prototype.toString.call(list) !== '[object Array]' || list.length > 20) return null;
    for (i = 0; i < list.length; i += 1) {
      rate = list[i];
      name = rate && rate.name;
      price = rate && rate.price;
      rateCurrency = rate && rate.currency;
      if (typeof name !== 'string' || !name.replace(/^\s+|\s+$/g, '') || name.length > 100 || /[\x00-\x1f\x7f]/.test(name)) return null;
      if (typeof price !== 'string' || !/^\d{1,6}(?:\.\d{1,2})?$/.test(price) || !isFinite(Number(price))) return null;
      if (rateCurrency && rateCurrency !== currency) return null;
      result.push({ name: name, price: Number(price).toFixed(2), currency: currency });
    }
    return result;
  }
  function display(root, quote) {
    var list = field(root, 'shipping-rates'), item, i;
    clearDisplay(root, quote.rates.length ? 'Shipping options for this cart:' : 'No shipping options were returned for this ZIP code. Check your details or continue to checkout.');
    for (i = 0; i < quote.rates.length; i += 1) {
      item = document.createElement('li');
      item.textContent = quote.rates[i].name + ': ' + quote.rates[i].currency + ' ' + quote.rates[i].price;
      list.appendChild(item);
    }
    list.hidden = !quote.rates.length;
  }
  function quote(root, done) {
    var where, ticket, prefix, first;
    if (rootNow() !== root) { if (done) done({ status: 'no_cart', message: 'Open the cart to check shipping options.' }); return; }
    if (active && active.root === root && active.busy) { if (done) done({ status: 'busy', message: 'A shipping check is already running.' }); return; }
    where = destination(root);
    invalidate('');
    if (!where) { clearDisplay(root, 'Choose a US state and enter a 5-digit ZIP code.'); if (done) done({ status: 'invalid_destination', message: 'Choose a US state and enter a 5-digit ZIP code.' }); return; }
    ticket = ++serial;
    active = { root: root, ticket: ticket, busy: true, quote: null, done: done || null };
    prefix = base(root);
    field(root, 'shipping-check').disabled = true;
    clearDisplay(root, 'Checking shipping options...');
    active.xhr = request('GET', prefix + 'cart.js', function (error, cart) {
      if (!stillCurrent(root, ticket)) return;
      first = !error && cartFacts(cart);
      if (!first) { fail(root, ticket, 'We could not check this cart. Please try again or continue to checkout.'); return; }
      active.xhr = request('POST', prefix + 'cart/prepare_shipping_rates.json?' + params(where), function (prepareError) {
        if (!stillCurrent(root, ticket)) return;
        if (prepareError) { fail(root, ticket, 'Shipping options are unavailable right now. Please continue to checkout.'); return; }
        poll(0);
      });
    });
    function poll(attempt) {
      if (!stillCurrent(root, ticket)) return;
      if (attempt >= 5) { fail(root, ticket, 'Shipping options took too long. Please continue to checkout.'); return; }
      active.xhr = request('GET', prefix + 'cart/async_shipping_rates.json?' + params(where), function (error, data) {
        var rates;
        if (!stillCurrent(root, ticket)) return;
        if (error) { fail(root, ticket, 'Shipping options are unavailable right now. Please continue to checkout.'); return; }
        if (data === null) { active.timer = window.setTimeout(function () { if (active && active.ticket === ticket) active.timer = null; poll(attempt + 1); }, 700); return; }
        rates = ratesFrom(data, first.currency);
        if (!rates) { fail(root, ticket, 'Shipping options could not be checked. Please continue to checkout.'); return; }
        active.xhr = request('GET', prefix + 'cart.js', function (cartError, cart) {
          var last = !cartError && cartFacts(cart);
          if (!stillCurrent(root, ticket)) return;
          if (!sameDestination(where, destination(root)) || !last || last.fingerprint !== first.fingerprint) { fail(root, ticket, 'Your cart or ZIP code changed. Check shipping options again.'); return; }
          active.busy = false;
          active.quote = { rates: rates, currency: first.currency, fingerprint: first.fingerprint, destination: where, expiresAt: Date.now() + 300000 };
          field(root, 'shipping-check').disabled = false;
          display(root, active.quote);
          active.timer = window.setTimeout(function () { if (active && active.ticket === ticket) invalidate('Shipping options may have changed. Check them again.'); }, 300000);
          if (active.done) active.done({ status: 'ready', services: rates, arrival_date_known: false, message: 'These shipping prices are estimates. Final shipping and tax are shown at checkout. No arrival date is promised.' });
        });
      });
    }
  }
  function nodeFor(target) {
    while (target && target !== document) {
      if (target.getAttribute && target.getAttribute('data-ps-cart-shipping-quote') !== null) return target;
      target = target.parentNode;
    }
    return null;
  }
  document.addEventListener('click', function (event) {
    var target = event.target, root;
    if (!target || !target.getAttribute || target.getAttribute('data-ps-shipping-check') === null) return;
    root = nodeFor(target);
    if (root) quote(root);
  });
  function changed(event) {
    var target = event.target;
    if (!target || !target.getAttribute) return;
    if (target.getAttribute('data-ps-shipping-state') !== null || target.getAttribute('data-ps-shipping-zip') !== null) invalidate('Check shipping options for the new ZIP code.');
  }
  document.addEventListener('change', changed);
  document.addEventListener('input', changed);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { invalidate('Your cart changed. Check shipping options again.'); });
  if (window.MutationObserver && document.body) {
    var observer = new window.MutationObserver(function () { if (active && rootNow() !== active.root) invalidate(''); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  ps.cartShippingQuote = {
    readVisibleQuote: function (done) {
      var root = rootNow(), record = active, ticket, prefix;
      if (root && record && record.root === root && record.busy) { done({ status: 'pending', message: 'The shipping check is still running. Read the visible result when it finishes.' }); return; }
      if (!root || !record || record.root !== root || !record.quote || !sameDestination(destination(root), record.quote.destination)) {
        done({ status: 'no_quote', message: 'Ask the shopper to check shipping options on this cart.' }); return;
      }
      if (Date.now() >= record.quote.expiresAt) { invalidate('Shipping options may have changed. Check them again.'); done({ status: 'no_quote', message: 'Shipping options expired. Check them again.' }); return; }
      ticket = record.ticket;
      prefix = base(root);
      record.xhr = request('GET', prefix + 'cart.js', function (error, cart) {
        var facts = !error && cartFacts(cart), services = [], i;
        if (!current(root, ticket)) { done({ status: 'no_quote', message: 'The cart changed. Check shipping options again.' }); return; }
        if (!facts || facts.fingerprint !== record.quote.fingerprint) {
          invalidate('Your cart changed. Check shipping options again.');
          done({ status: 'no_quote', message: 'The cart changed. Check shipping options again.' }); return;
        }
        for (i = 0; i < record.quote.rates.length; i += 1) {
          var serviceName = record.quote.rates[i].name;
          var where = record.quote.destination;
          if (serviceName.indexOf(where.zip) >= 0 || serviceName.toLowerCase().indexOf(names[states.indexOf(where.state)].toLowerCase()) >= 0 || new RegExp('(^|[^A-Za-z])' + where.state + '([^A-Za-z]|$)', 'i').test(serviceName)) serviceName = 'Shipping option ' + (i + 1);
          services.push({ name: serviceName, price: record.quote.rates[i].price, currency: record.quote.rates[i].currency });
        }
        done({ status: services.length ? 'ready' : 'no_options', services: services, arrival_date_known: false, message: services.length ? 'These shipping prices are estimates. Final shipping and tax are shown at checkout. No arrival date is promised.' : 'No shipping options were returned for this ZIP code. Check your details or continue to checkout.' });
      });
    }
  };
  if (document.modelContext && typeof document.modelContext.registerTool === 'function') {
    try {
      document.modelContext.registerTool({
        name: 'paintscratch_shipping_options',
        description: 'Read shipping prices already shown in the visible PaintScratch cart, or check new prices only when the shopper explicitly supplied a US state and ZIP code. Never infer or reuse a destination from a paint choice, browser, or prior tool call. When both state and zip are supplied, show them in the cart form and run the same quote action as the button. These are estimated shipping prices, not an arrival date. Final shipping and tax are shown at checkout. This tool does not add items, select shipping, or place an order.',
        inputSchema: { type: 'object', properties: { state: { type: 'string', enum: states }, zip: { type: 'string', pattern: '^[0-9]{5}(-[0-9]{4})?$' } }, additionalProperties: false },
        annotations: { readOnlyHint: false, untrustedContentHint: true, consequentialHint: false },
        execute: function (input) {
          var keys, hasState, hasZip, root, state, zip;
          input = input || {};
          if (Object.prototype.toString.call(input) !== '[object Object]') return window.Promise.resolve(JSON.stringify({ status: 'invalid_destination', message: 'Supply both an explicit US state and ZIP code, or neither to read the visible quote.' }));
          keys = Object.keys(input); hasState = Object.prototype.hasOwnProperty.call(input, 'state'); hasZip = Object.prototype.hasOwnProperty.call(input, 'zip');
          if (keys.length > 2 || hasState !== hasZip || (keys.length && !hasState)) return window.Promise.resolve(JSON.stringify({ status: 'invalid_destination', message: 'Supply both an explicit US state and ZIP code, or neither to read the visible quote.' }));
          if (!hasState) return new window.Promise(function (resolve) { ps.cartShippingQuote.readVisibleQuote(function (result) { resolve(JSON.stringify(result)); }); });
          state = input.state; zip = input.zip;
          if (typeof state !== 'string' || states.indexOf(state) < 0 || typeof zip !== 'string' || !/^\d{5}(?:-\d{4})?$/.test(zip)) return window.Promise.resolve(JSON.stringify({ status: 'invalid_destination', message: 'Use a real US state abbreviation and a 5-digit ZIP code supplied by the shopper.' }));
          root = rootNow();
          if (!root) return window.Promise.resolve(JSON.stringify({ status: 'no_cart', message: 'Open the cart to check shipping options.' }));
          if (active && active.root === root && active.busy) return window.Promise.resolve(JSON.stringify({ status: 'busy', message: 'A shipping check is already running. Read the visible result when it finishes.' }));
          field(root, 'shipping-state').value = state;
          field(root, 'shipping-zip').value = zip;
          return new window.Promise(function (resolve) {
            var finished = false, toolTimeout = null;
            function finish(result) { if (finished) return; finished = true; if (toolTimeout) window.clearTimeout(toolTimeout); resolve(JSON.stringify(result)); }
            toolTimeout = window.setTimeout(function () { finish({ status: 'pending', message: 'The shipping check is still running. Read the visible result when it finishes.' }); }, 14000);
            quote(root, function (result) {
              if (finished) return;
              if (result.status !== 'ready') { finish(result); return; }
              ps.cartShippingQuote.readVisibleQuote(finish);
            });
          });
        }
      });
    } catch (_e) {}
  }
}());
